import { compose, pick, reduce, zip } from 'lodash/fp';
import { ServiceOrderNote } from '@mews-commander/types';
import { ServiceOrderNoteType } from '@mews-commander/legacy-data-structures';
import { CompactedNote } from './types';

export const getNoteLabelEnumValue = (note: ServiceOrderNote) => ServiceOrderNoteType.getByName(note.type);

const cleanNote = pick(['createdUtc', 'id', 'serviceOrderId', 'text', 'type']);

const toListOfSimpleNotes = ({ ids, serviceOrderIds, ...note }: CompactedNote) =>
    compose(
        reduce(
            (acc: $TSFixMe, [id, serviceOrderId]: $TSFixMe) => [...acc, { ...cleanNote(note), id, serviceOrderId }],
            []
        ),
        zip(ids)
    )(serviceOrderIds);

export const expandCombinedNotes = reduce(
    (acc: ServiceOrderNote[], note: CompactedNote) => [
        ...acc,
        ...(note.ids ? toListOfSimpleNotes(note) : [cleanNote(note)]),
    ],
    []
);
